import type { FC } from 'react';
import { createContext, ReactElement, useContext } from 'react';
import { ILoginData } from '../types/loginData';
import { gotoSignInPage } from '../utils';

const ValidateUserContext = createContext<ILoginData | null>(null);

interface IProps {
  data: ILoginData | null;
  render?: (data: ILoginData | null) => ReactElement | null;
}
export const ValidateUserProvider: FC<IProps> = (props) => {
  return (
    <ValidateUserContext.Provider value={props.data}>
      {props.children}
      {props.render?.(props.data)}
    </ValidateUserContext.Provider>
  );
};

export function useValidateUserData(): ILoginData | null {
  return useContext(ValidateUserContext);
}

export function useUserData(): ILoginData {
  const loginData = useContext(ValidateUserContext);
  if (!loginData) {
    gotoSignInPage();
    throw new Error(
      'tried to consume context outside provider or user not logged in',
    );
  }
  return loginData;
}
